<template>
      <b-overlay :show="showOverlay">
        <Breadcrumb/>
        <b-sidebar
            id="sidebar-right-add"
            shadow
            right
            bg-variant="white"
            backdrop
        >
          <add-operator
            @show-message="closeSideBarAdd"
            @refetch-data="getOperators"
            :listagemOperadores="rows"
            :listagemWorkcenters="workcentersList"
          />
        </b-sidebar>
        <b-sidebar
            id="sidebar-right-edit"
            shadow
            right
            bg-variant="white"
            backdrop
        >
          <edit-operator
            :current-workcenter-id="currentOperatorId" 
            @show-message="closeSideBarEdit"
            @refetch-data="getOperators"
            :contextoList="listagemContexto"
            :listagemOperadores="rows"
            :listagemWorkcenters="workcentersList"

          />
        </b-sidebar>
        
        <b-card title="Lista de Operadores">
            <div>
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button
                        variant="primary"
                        v-b-toggle.sidebar-right-add
                        class="btn-add-operator"
                        >
                        <PlusIcon/>
                        <span class="text-nowrap">Novo Operador</span>
                        </b-button>
                    </div>
                  </b-form-group>
                </div>

                <b-table 
                  v-if="rows.length > 0"
                  :rows="rows"
                  :fields="fields"
                  :stickyHeader="false"
                  class="table-responsive"
                >
                  <template v-slot:cell(action)="data">
                    <span>
                        <b-dropdown
                        variant="link"
                        toggle-class="text-decoration-none"
                        no-caret
                        class="dropdown-action"
                        >
                        <template v-slot:button-content>
                            <feather-icon
                            icon="MoreVerticalIcon"
                            size="16"
                            class="text-body align-middle mr-25"
                            />
                        </template>
                        <b-dropdown-item  @click="setCurrentOperator(data.item.id)">
                            <EditIcon/>
                            <span>Editar</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click="deleteOperator(data.item.id)">
                            <DeleteIcon/>
                            <span>Apagar</span>
                        </b-dropdown-item>
                        </b-dropdown>
                    </span>
                  </template>
                </b-table>

                <div class="demo-spacing-0">
                  <b-alert variant="primary" :show="(showOverlay == false && rows.length == 0) ? true : false" >
                    <div class="alert-body">
                      <span>Nenhum resultado encontrado.</span>
                    </div>
                  </b-alert>
                </div>
            </div>
        </b-card>
        <b-button hidden ref="closeAddStatus" v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-b-toggle.sidebar-right-add></b-button>
        <b-button hidden ref="closeEditStatus" v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-b-toggle.sidebar-right-edit></b-button>
      </b-overlay>
</template>

<script>
import Breadcrumb from '../../../layouts/components/Breadcrumb.vue'
import {
  BRow, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BAlert, BDropdown, BDropdownItem, BCard, BOverlay, BSidebar, VBToggle, BButton
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AddOperator from './AddOperators.vue'
import EditOperator from './EditOperator.vue'
import BTable from '@core/components/b-table/BTable.vue'
import PlusIcon from '@/assets/images/pages/plus-icon.svg'
import EditIcon from '@/assets/images/pages/edit-icon.svg'
import DeleteIcon from '@/assets/images/pages/delete-icon.svg'

export default {
  components: {
    BRow,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BCard,
    BOverlay,
    ToastificationContent,
    BSidebar,
    BButton,
    AddOperator,
    EditOperator,
    Breadcrumb,
    BTable,
    PlusIcon,
    EditIcon,
    DeleteIcon
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  data() {
    return {
      workcentersList:[],
      pageLength: 10,
      dir: false,
      currentOperatorId: '',
      fields: [
        {
          label: 'Nome',
          key: 'name',
          sortable: true
        },
        {
          label: 'Empresa',
          key: 'company_code',
          sortable: true
        },
        {
          label: 'Matrícula',
          key: 'employee_id',
          sortable: true
        },
        {
          label: 'Centro de Trabalho',
          key: 'workcenter',
          sortable: true
        },
        {
          label: 'Ação',
          key: 'action',
          sortable: true,
          class:"col-sm-header"
        },
      ],
      rows: [],
      searchTerm: '',
      showOverlay: false,
      listagemContexto:[],

    }
  },
  methods: {
    getWorkcenters(){
      this.$http.get(`/api/operators/context`)
        .then(res => { 
          this.workcentersList = res.data.workcenters.map((item) => {return {label: item.name, value: item.id}});
        })
    },
    getCurrentOperatorContext(id){
      this.$http.get(`/api/operators/${id}`)
        .then((response) => { 
          this.listagemContexto = response.data
        })
        setTimeout(this.openEditOperator,600);
      
    },
    openEditOperator(){
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right-edit')
    },
    setCurrentOperator(id){
      this.currentOperatorId = id
      this.listagemContexto = []
      this.getCurrentOperatorContext(this.currentOperatorId);
    },
    getOperators(){
      this.$http.get(`/api/operators`)
        .then(res => { 
          this.rows = res.data;
          this.showOverlay = false; })
    },
    closeSideBarAdd(){
      this.$refs.closeAddStatus.click()
    },
    closeSideBarEdit(){
      this.$refs.closeEditStatus.click()
    },
    deleteOperator(id){
      this.$swal({
        title: 'Tem certeza?',
        text: "Você perderá esses dados e não poderá recuperá-los.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Apagar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
          text: 'text-modal'
        },
        buttonsStyling: false,
      }).then(result => {
        this.showOverlay = true;
        if (result.value) {
          this.$http.put(`/api/operators/${id}/delete`)
            .then(() => {
              this.getOperators()
              this.showToast('Sucesso', 'SmileIcon', 'Operador excluído com sucesso', 'success')
            })
            .catch((error) => {
              this.showToast('Error!', 'FrownIcon', error.response.data.message, 'danger')
            })
        }
        this.showOverlay = false;
      })
    },
    showToast(title, icon, text, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: icon,
          text: text,
          variant,
        },
      })
    },
  },
  created() {
    this.showOverlay = true;
    this.getOperators();
    this.getWorkcenters()
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-good-table.scss';
@import '~@core/scss/vue/libs/vue-sweetalert.scss';

.col-sm-header{
 width: 5% !important;
}

.b-sidebar{
  width: 360px;
}

.btn-add-operator{
  display: flex;
  align-items: center;
  svg{
    margin-right: 8px;
  }
  span{
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  }
}

.dropdown-action{
  .dropdown-item{
    display: flex;
    align-items: center;
    svg{
      margin-right: 9px;
    }
    &:hover{
      svg{
        path{
          stroke: #EE740C !important;
          fill: #fff !important;
        }
      }
    }
    &:focus{
      svg{
        path{
          fill: #EE740C !important;
          stroke: #ffff !important;
        }
      }
    }
  }
}


.swal2-container {
  .swal2-title{
    font-family: 'Montserrat' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 28px !important;
    line-height: 34px !important;
  }
  .swal2-content{
    padding: 0;
     .swal2-html-container{
      font-family: 'Montserrat';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      
    }
  }
 
}
</style>
